import selectFallbackCat from '../FallbackImageSelect/FallbackImageSelect';

// Define the expected structure for fallback images
interface FallbackFolder {
  name: string;
  path: string;
  files: string[];
}
export const sitenameImageIndexHandler = (sitenameImageIndex: any, fallbackimages: FallbackFolder[], primarySiteName: string) => {
  // Select the fallback category based on the  primary site name
  const primarySiteNameCat = selectFallbackCat(primarySiteName);

  // Get the current image index for the selected category, defaulting to 0 if not set
  const imageIndex = sitenameImageIndex[primarySiteNameCat] ? sitenameImageIndex[primarySiteNameCat] : 0;

  // Increment the image index for the next use
  sitenameImageIndex[primarySiteNameCat] = imageIndex + 1;
  if (fallbackimages) {
    /* Retrieving images from the corresponding category folder */
    let fallbackCatFiles = fallbackimages.find(folder => primarySiteNameCat == folder.name);
    let modeOfSitenameImageIndex = 0;

    // Check if 'fallbackCatFiles' exists
    if (fallbackCatFiles && fallbackCatFiles.files.length > 0) {
      // Determine the index for selecting an image
      if (imageIndex == 0) {
        modeOfSitenameImageIndex = 0; // If index is 0, set it directly
      } else {
        // Use modulo to ensure the index stays within bounds of the file array
        modeOfSitenameImageIndex = imageIndex % fallbackCatFiles.files.length;
      }

      // Add the selected image path to the 'fallbacks' array
      return fallbackCatFiles.path + fallbackCatFiles.files[modeOfSitenameImageIndex];
    }
    return '';
  }
  return '';
};